
<template>
    <div>
        <div class="col-lg-8" v-if="records && records.length > 0">
            <small class="font-weight-bold">
                Showing {{ pagination.from == 0 ? 1 : pagination.from }} - {{ pagination.to }} of
                {{ pagination.total }} entries
            </small>
        </div>

        <div
            class="card shadow"
            v-if="records && records.length > 0"
        >
            <div class="table-responsive">
                <base-table
                    class="table align-items-center table-flush"
                    thead-classes="thead-light"
                    tbody-classes="list"
                    :data="records"
                >
                    <template slot="columns">
                        <th width="2%">S/N</th>
                        <th>School's Name</th>
                        <th>Accreditation <br> Status</th>
                        <th>School Type</th>
                        <th>Current <br> Quota</th>
                        <th>Expiry Date</th>
                    </template>

                    <template
                        slot-scope="{row, index}"
                    >
                        <td class="budget">
                            {{ pagination.from+index}}
                        </td>
                        <td class="text-capitalize">
                            <span
                                v-if="row.name"
                                v-html="breakWord(row.name)"
                            ></span>
                            <span v-if="! row.name">N/A</span>
                        </td>
                        <td class="text-capitalize">
                            {{ row.accredit_status ? getExactAccreditStatus(row.accredit_status) : 'N/A'}}
                        </td>
                        <td class="text-capitalize">
                            {{ row.type ? row.type : 'N/A'}}
                        </td>
                        <td class="text-capitalize">
                            {{ row.quota ? row.quota : 'N/A'}}
                        </td>
                        <td>
                            {{ row.expiry_year | formatDate }}
                        </td>
                    </template>
                </base-table>
            </div>

            <div
                class="card-footer d-flex justify-content-end bg-transparent"
                v-if="hasPagination"
                    @click="paginate"
            >
                <base-pagination
                    :total="pagination.total"
                    align="center"
                    v-model="pagination.number"
                    :perPage="pagination.perPage"

                >
                </base-pagination>
            </div>

            <div class="col-lg-12">
                <hr>
                <div class="container">
                    <h3 class="text-uppercase">
                        Total Number of Training Schools Accredited:
                        <span class="right">
                            {{ accreditedCount }}
                        </span>
                    </h3>

                    <h3 class="text-uppercase">
                        Total Number of Training Schools Awaiting Accreditation:
                        <span class="right">
                            {{ waitingCount }}
                        </span>
                    </h3>
                </div>
                <hr>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    import Badge from '../../../components/Badge.vue';

    export default {
    components: { Badge },
        name: 'SchoolReportingData',
        props: ['records', 'hasPagination', 'pagination', 'paginate', 'privileges', 'accreditedCount',
            'waitingCount'],
        filters: {
            formatDate(date) {
                return date ? moment(date).format('Do MMM, YYYY') : 'N/A';
            }
        },
        methods: {
            getExactAccreditStatus(status) {// get full name
                return status && ((status == 'final-clinical-accreditation') || (status == 're-accreditation')) ? 
                    'Full Accreditation' : 'Partial Accreditation';
            },
            breakWord(word, length = 40) {// break word into two parts
                if(word) {
                    let textLength = word.length;
                    let exploded = word.split(' ');
                    if(word && textLength < length) {
                        return word;
                    } else if(word) {
                        let formedWord = '';
                        let half = (exploded.length > 2) ? Math.ceil((exploded.length - 1)/2) : 0;
                        for(let phrase of exploded) {
                            formedWord += phrase+' ';
                            if(exploded[half] == phrase) {
                                formedWord += ' <br> ';
                            }
                        }
                        return formedWord;
                    }
                }
                return 'N/A';
            }
        }
    };
</script>
<style>
    .table td {
        font-size: 15px;
    }
    .right {
        float: right !important;
    }
</style>
